import React from 'react';
import './Step1Infos.css';

const Step1Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-1">
        Con il mouse o con il dito, disegna l'area del tetto che copre la tua casa sulla quale verrà ospitato il tuo impianto fotovoltaico.<br />
        Per  disegnare nuovamente l'area del tuo tetto clicca il tasto  “Cancella” in alto a sinistra.
        </div>
    );
}

export default Step1Infos;